const getDomainFromEmail = (email: string) => email.split('@')[1]

export default getDomainFromEmail
